import { styled } from "@mui/system";
import { SwipeableListItem } from "react-swipeable-list";
import { Box } from "@mui/material";

export const SwipeableListItemStyled = styled(SwipeableListItem)({
    "& .swipeable-list-item__content": {
        alignItems: "start",
    },
});

export const SwipeableCommentListItemStyled = styled(SwipeableListItem)({
    maxHeight: "none",
    "& .swipeable-list-item__content": {
        alignItems: "start",
        flexDirection: "column",
    },
});

export const MessageIndicatorContainer = styled(Box)({
    display: "flex",
    alignItems: "end",
    minWidth: "20px",
});

export const SwipeableListItemContentContainer = styled("div")({
    ".swipeable-list__item-content-center": {
        color: "black",
        flex: "1",
        height: "100%",
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    ".swipeable-list__content": {
        color: "black",
        flex: "1",
        height: "100%",
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        alignItems: "end",
    },
    ".swipeable-list__icon": {
        fill: "black",
        width: "20px",
        height: "20px",
        marginTop: "-4px",
    },

    ".swipeable-list-item": {
        maxHeight: "fit-content",
    },
});
